export const Tabs = (target: HTMLDivElement) => {

  const el = {
    buttons: target.querySelectorAll<HTMLButtonElement>('.tabs .tabs__button'),
    tabs: target.querySelectorAll<HTMLDivElement>('.tab'),
  }

  const method = {
    init: () => {
      el.buttons.forEach(button => button.addEventListener('click', method.onClick))
    },

    onClick: (e: Event & { target: HTMLButtonElement }) => {
      const { index = '' } = e.target.dataset
      const tab = target.querySelector(`.tab[data-index="${index}"]`)
      if (!tab) return

      el.tabs.forEach(x => x.classList.remove('tab--visible'))
      tab.classList.add('tab--visible')

      el.buttons.forEach(x => x.parentElement.classList.remove('tabs__item--selected'))
      const tabsItem = e.target.parentElement as HTMLLIElement
      tabsItem.classList.add('tabs__item--selected')
    },
  }

  method.init()
}